import { Component, input, output } from '@angular/core';
import { ButtonComponent as SdcButtonComponent } from '@3ddv/software-division-components/generic/button';

export type GsActionTone = 'positive' | 'negative';

export interface GsAction {
  id: string;
  label: string;
  variant: 'secondary' | 'destructive';
  dataCy: string;
  indicator?: boolean;
  tone?: GsActionTone;
}

@Component({
  selector: 'gs-action-cell',
  imports: [SdcButtonComponent],
  templateUrl: './gs-action-cell.component.html',
  styleUrls: ['./gs-action-cell.component.css'],
  host: {
    '[attr.data-cy]': 'rowDataCy()',
  },
})
export class GsActionCellComponent {
  readonly actions = input<GsAction[]>([]);

  readonly rowDataCy = input<string | undefined>(undefined);

  readonly actionClick = output<string>();
}
